import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getFacetsWithSelections,
  getSelectedFacetValues,
} from "../modules/search/selectors";
import {
  changeMultiFacet,
  clearAlwaysApply,
} from "../modules/search/domains/filters/thunks";

export function useSelectedFacets() {
  const dispatch = useDispatch();

  const selectedFacets = useSelector(getFacetsWithSelections);
  const displayedFacetValues = useSelector(getSelectedFacetValues);

  const onChangeMultiFacet = useCallback(
    (toggledFacets) => {
      dispatch(changeMultiFacet(toggledFacets));
    },
    [dispatch],
  );

  const onClearAlwaysApply = useCallback(
    (facetId) => {
      dispatch(clearAlwaysApply(facetId));
    },
    [dispatch],
  );

  return {
    selectedFacets,
    displayedFacetValues,
    changeMultiFacet: onChangeMultiFacet,
    clearAlwaysApply: onClearAlwaysApply,
  };
}
